// WebSocket routes
export const WS_ROUTES = {
  NOTE: (orgSlug: string) => `${getWebSocketBaseUrl()}${orgSlug}/notebook/`,
  NOTIFICATIONS: (userId: string | number) => `${getWebSocketBaseUrl()}/notifications/${userId}/`,
};

function getWebSocketBaseUrl(): string {
  const apiUrl = process.env.NEXT_PUBLIC_WS_URL;
  return `${apiUrl}/ws`;
}
